define(function (require, exports, module) {
    'use strict';

    var requestMicrotask = require('./requestMicrotask');
    var AsyncIterator = require('./AsyncIterator');

    /**
     * Examples of using the AsyncRepeat:
     *
     * | new AsyncRepeat(function (repeat, finish) {
     * |     ping().then(finish, repeat);
     * | }).then(function () {
     * |     console.log('online');
     * | });
     *
     * | new AsyncRepeat(function (repeat, finish, thrower) {
     * |     ping().then(repeat, thrower);
     * | }).catch(function () {
     * |     console.log('offline');
     * | });
     *
     * @param {ArrayLikeObject} iterable
     * @param {Function} callback – function (repeat:Function, finish:Function, thrower:Function) {…}
     * @param {Object} [thisObject]
     * @returns {Promise}
     */
    function AsyncRepeat(callback, thisObject) {
        var promise = AsyncIterator.call(this, null, callback, thisObject);

        return promise;
    }

    AsyncRepeat.prototype = Object.assign(Object.create(AsyncIterator.prototype), {
        constructor: AsyncRepeat,

        _onIteration: function () {
            var callback = this._callback;

            callback(this._next, this._finish, this._thrower);
        },

        _next: function () {
            if (!this._done) {
                requestMicrotask().then(this._onIteration).catch(this._onError);
            }
        },
    });

    module.exports = AsyncRepeat;
});
